var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _path4, _rect13, _rect14, _path5, _path6, _g, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 109.793,
    r: 109.663,
    fill: "#E8F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9778 45.4039C48.9778 43.2845 50.6959 41.5664 52.8153 41.5664H165.266V160.462H52.8153C50.6959 160.462 48.9778 158.744 48.9778 156.624V45.4039Z",
    fill: "#FBFBFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.0422,
    y: 50.1978,
    width: 16.8849,
    height: 16.8849,
    fill: "#49B7E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2454,
    y: 51.4038,
    width: 14.4728,
    height: 14.4728,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2454,
    y: 51.4038,
    width: 14.4728,
    height: 14.4728,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.9756,
    y: 58.6401,
    width: 61.2063,
    height: 1.91874,
    rx: 0.959372,
    fill: "#49B7E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3994,
    y: 58.6401,
    width: 7.59541,
    height: 1.91874,
    rx: 0.959372,
    fill: "#49B7E4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143.606,
    y: 65.2083,
    width: 61.2063,
    height: 1.91874,
    rx: 0.959372,
    transform: "rotate(-180 143.606 65.2083)",
    fill: "#49B7E4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154.183,
    y: 65.2083,
    width: 7.59541,
    height: 1.91874,
    rx: 0.959372,
    transform: "rotate(-180 154.183 65.2083)",
    fill: "#49B7E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 57.0422,
    y: 129.619,
    width: 16.8849,
    height: 16.8849,
    fill: "#49B7E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2454,
    y: 130.825,
    width: 14.4728,
    height: 14.4728,
    fill: "#BDBDBD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2454,
    y: 130.825,
    width: 14.4728,
    height: 14.4728,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 92.9756,
    y: 138.062,
    width: 61.2063,
    height: 1.91874,
    rx: 0.959372,
    fill: "#49B7E4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3999,
    y: 138.062,
    width: 7.59541,
    height: 1.91874,
    rx: 0.959372,
    fill: "#49B7E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.677 41.5664H173.816C174.664 41.5664 175.351 42.2536 175.351 43.1014V185.394C171.665 185.394 168.677 182.406 168.677 178.72V41.5664Z",
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.64 163.938H40.3079V170.044C40.3079 178.521 47.1803 185.394 55.6578 185.394H172.001C168.486 185.385 165.64 182.533 165.64 179.016V163.938Z",
    fill: "#FBFBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.818 46.6496C182.818 45.982 182.686 45.3211 182.431 44.7043C182.175 44.0876 181.801 43.5272 181.329 43.0552C180.857 42.5832 180.297 42.2088 179.68 41.9533C179.063 41.6979 178.402 41.5664 177.735 41.5664V46.6496H182.818Z",
    fill: "#FBFBFB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 61.2063,
    height: 1.91874,
    rx: 0.959372,
    transform: "matrix(-1 0 0 1 143.606 142.605)",
    fill: "#49B7E4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 7.59541,
    height: 1.91874,
    rx: 0.959372,
    transform: "matrix(-1 0 0 1 154.183 142.605)",
    fill: "#49B7E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9133 58.6576C64.2433 58.6576 65.2467 57.6543 65.2467 56.3243C65.2467 54.9943 64.2433 53.991 62.9133 53.991C61.5833 53.991 60.58 54.9943 60.58 56.3243C60.58 57.6543 61.5833 58.6576 62.9133 58.6576ZM63.58 59.2896H62.2467C60.4087 59.2896 58.9133 60.785 58.9133 62.623V63.2896H66.9133V62.623C66.9133 60.785 65.418 59.2896 63.58 59.2896ZM71.1093 56.151L68.2427 59.0123L67.3813 58.151L66.4387 59.0936L68.2427 60.8963L72.0507 57.095L71.1093 56.151Z",
    fill: "#49B7E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9133 138.933C64.2433 138.933 65.2467 137.929 65.2467 136.599C65.2467 135.269 64.2433 134.266 62.9133 134.266C61.5833 134.266 60.58 135.269 60.58 136.599C60.58 137.929 61.5833 138.933 62.9133 138.933ZM63.58 139.565H62.2467C60.4087 139.565 58.9133 141.06 58.9133 142.898V143.565H66.9133V142.898C66.9133 141.06 65.418 139.565 63.58 139.565ZM71.1093 136.426L68.2427 139.287L67.3813 138.426L66.4387 139.369L68.2427 141.171L72.0507 137.37L71.1093 136.426Z",
    fill: "#49B7E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1607_20014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.567 110.581H116.833V107.847H119.567V110.581ZM111.367 110.581H114.1V107.847H111.367V110.581ZM125.033 110.581H122.3V107.847H125.033V110.581Z",
    fill: "#49B7E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7 96.914V90.0807C97.7 88.8244 97.9474 87.5804 98.4282 86.4197C98.909 85.259 99.6137 84.2044 100.502 83.3161C101.39 82.4277 102.445 81.723 103.606 81.2423C104.766 80.7615 106.01 80.514 107.267 80.514C108.523 80.514 109.767 80.7615 110.928 81.2423C112.088 81.723 113.143 82.4277 114.031 83.3161C114.92 84.2044 115.624 85.259 116.105 86.4197C116.586 87.5804 116.833 88.8244 116.833 90.0807V96.914H120.933C122.021 96.914 123.064 97.346 123.832 98.1149C124.601 98.8838 125.033 99.9267 125.033 101.014V102.517C126.578 102.831 127.967 103.669 128.964 104.89C129.962 106.11 130.507 107.638 130.507 109.214C130.507 110.79 129.962 112.318 128.964 113.539C127.967 114.759 126.578 115.597 125.033 115.911V117.414C125.033 118.501 124.601 119.544 123.832 120.313C123.064 121.082 122.021 121.514 120.933 121.514H93.6C92.5126 121.514 91.4698 121.082 90.7009 120.313C89.932 119.544 89.5 118.501 89.5 117.414V101.014C89.5 99.9267 89.932 98.8838 90.7009 98.1149C91.4698 97.346 92.5126 96.914 93.6 96.914H97.7ZM100.433 90.0807C100.433 88.2684 101.153 86.5303 102.435 85.2488C103.716 83.9673 105.454 83.2474 107.267 83.2474C109.079 83.2474 110.817 83.9673 112.099 85.2488C113.38 86.5303 114.1 88.2684 114.1 90.0807V96.914H100.433V90.0807ZM112.733 105.114C111.646 105.114 110.603 105.546 109.834 106.315C109.065 107.084 108.633 108.127 108.633 109.214C108.633 110.301 109.065 111.344 109.834 112.113C110.603 112.882 111.646 113.314 112.733 113.314H123.667C124.754 113.314 125.797 112.882 126.566 112.113C127.335 111.344 127.767 110.301 127.767 109.214C127.767 108.127 127.335 107.084 126.566 106.315C125.797 105.546 124.754 105.114 123.667 105.114H112.733Z",
    fill: "#49B7E4"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.068 93.0977C158.938 93.9688 159.971 94.6593 161.108 95.1297C162.246 95.6002 163.465 95.8412 164.696 95.839C165.927 95.8412 167.147 95.6001 168.284 95.1297C169.422 94.6593 170.456 93.9687 171.326 93.0977L176.628 87.7934L173.977 85.1421L168.675 90.4465C167.618 91.4984 166.188 92.0889 164.697 92.0889C163.206 92.0889 161.776 91.4984 160.719 90.4465C159.666 89.3904 159.075 87.9599 159.075 86.4687C159.075 84.9774 159.666 83.547 160.719 82.4909L166.023 77.1884L163.372 74.5371L158.068 79.8396C156.312 81.5992 155.327 83.9832 155.327 86.4687C155.327 88.9541 156.312 91.3381 158.068 93.0977ZM187.235 77.1884C188.99 75.4283 189.975 73.0445 189.975 70.5593C189.975 68.0742 188.99 65.6903 187.235 63.9302C185.476 62.1749 183.092 61.1891 180.606 61.1891C178.121 61.1891 175.737 62.1749 173.977 63.9302L168.675 69.2346L171.326 71.8859L176.628 66.5815C177.685 65.5296 179.115 64.9391 180.606 64.9391C182.097 64.9391 183.527 65.5296 184.584 66.5815C185.637 67.6376 186.228 69.0681 186.228 70.5593C186.228 72.0506 185.637 73.481 184.584 74.5371L179.28 79.8396L181.931 82.4909L187.235 77.1884Z",
    fill: "#49B7E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.021 87.7953L163.368 85.144L179.281 69.2328L181.933 71.8859L166.021 87.7953Z",
    fill: "#49B7E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1607_20014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(89.5 80.514)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.5e73d2dfb17d504dabf3558d6676b463.svg";
export { ForwardRef as ReactComponent };